import { Role } from 'core/types/role';

import { Action, SET_ROLES } from './actions';

export default (state: Role[] = [], action: Action) => {
  switch (action.type) {
    case SET_ROLES:
      return action.payload;

    default:
      return state;
  }
};
